
<template>
  <div>

    <h1 class="pageHeading">{{$t('gen-Home')}}</h1>
    <p class="subHeading">{{$t('gen-Its-where-the-heart-is')}}</p>
    <loader v-if="view.loadingOrgs" />
  
    <div v-else class="pageContent bg-secondary">

      <div v-if="orgs.length" class="flex flex-wrap">
        <router-link 
          :to="org.name+'/home'" v-for="org in orgs" :key="org.id"
          class="org animated bg-primary">
          <ik-image
            v-if="org && org.logo.basic"
            :path="org.logo.basic"
            :transformation="[{height:60,width:60,dpr:$config.dpr,cm:'pad_resize'}]"
            loading="lazy"
            height="60"
            width="60"
            class="mr-3"
          />
          <div class="text-left">
            <p class="font-semibold text-gray-700 mb-1">
              {{org.name}}
            </p>
            <div v-if="isTeammateForOrg(org)">
              <div class="text-xs text-gray-500">
                <span class="mr-2">
                  {{$t('org-Teammates')}}: {{org.teammates.length || '0'}}
                </span>
                <span>
                  {{$t('org-Guests')}}: {{org.guests.length || '0'}}
                </span>
              </div>
              <div class="text-xs text-gray-500">
                {{$t('gen-Updated')}}: {{getTimeWords(org.updatedDate.toDate())}}
              </div>
            </div>
          </div>
        </router-link>
      </div>
      <div v-else class="text-center">
        <p>{{$t('account-You-dont-currently-own-or-are-a-member-of')}}</p>
      </div>

      <div class="my-5 text-center pt-3">
        <router-link to="/s/create" class="button lg" :class="[orgs.length > 0 ? 'clear' : 'primary']">
          {{$t('button-Create-Organisation')}}
        </router-link>
      </div>
    </div>

    <div v-if="view.error">
      <p>{{view.error}}</p>
    </div>

    <div v-if="user.adminConfig.viewJSON">
      JSON:
      <vue-json-pretty
        :data="orgs"
        >
      </vue-json-pretty>
    </div>

  </div>

</template>


<script>
import { formatDistance } from 'date-fns'

export default {
  name: 'Home',
  components: {

  },
  props: {
    // msg: String
  },
  data: function(){
    return {
      view: {
        error: null,
        loadingOrgs: true,
        signUpModal: {
          show: false,
          error: "",
          loading: false,
          status: null
        }
      }
    }
  },
  computed: {
    user () {
      return this.$store.getters.userData
    },
    userAdminStatus () {
      return this.$store.state.userAdminStatus
    },
    orgs () {
      return this.$store.getters.allOrgs
    },
    orgAccess () {
      return this.$store.getters.activeOrgAccess;
    }
  },
  mounted: async function(){
    console.log("home mounted, orgs:", this.orgs);

    if(this.orgs && this.orgs.length) {
      this.view.loadingOrgs = false;
    }

    if((!this.orgs || !this.orgs.length)  && this.user){
      console.log('triggering getOrgs from home')
      let orgs = await this.$store.dispatch("getOrgs", this.user)
      if(!this.orgs){
        this.view.error = "Sorry, you don't have access to any organisations"
      }      
      this.view.loadingOrgs = false;
    }
    
    if (!this.user) {
      console.log("no user, ask for login")
      this.$router.push("/login")
    }
  },
  // beforeRouteLeave (to, from, next) {
  //   // called when the route that renders this component is about to
  // },
  methods: {
    getTimeWords (time) {
      let res = formatDistance(
        new Date(time),
        new Date(),
        { addSuffix: true }
      ) 
      return res
    },
    isTeammateForOrg(org) {
      if(this.userAdminStatus) return true
      if(org.teammates.includes(this.user.id)) return true
      return false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

  .disabled {
    @apply opacity-50 cursor-not-allowed;
  }

  .org {
    @apply rounded-lg py-4 w-full px-4 mb-3 text-center flex items-center;
  }

  .org:hover {
    @apply border-gray-200;
  }

</style>
